











import { api } from "@/api/api";
import { ApiGetApplicationFormTemplateDto } from "@/api/generated/Api";
import BaseModalForm from "@/components/shared/modal/BaseModalForm.vue";
import { ModalType } from "@/shared/enums/modalTypeEnum";
import { NotificationItemType } from "@/shared/enums/notificationItemEnum";
import { globalLoadingWrapper } from "@/shared/helpers/loadingHelpers";
import { openNotification } from "@/shared/helpers/store.helpers";
import { useStore } from "@/shared/useHelpers";
import { StoreState } from "@/store/store.state.interface";
import { defineComponent, PropType } from "@vue/composition-api";

export default defineComponent({
  name: "ApplicationFormDeleteModal",
  components: { BaseModalForm },
  props: {
    modalType: {
      type: String as PropType<ModalType>,
      required: true,
    },
    headline: {
      type: String,
      required: true,
    },
    existingItemModal: {
      type: Object as PropType<ApiGetApplicationFormTemplateDto>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const store = useStore<StoreState>();
    const handleSubmit = () => {
      if (props.modalType !== ModalType.Delete) {
        openNotification(store, NotificationItemType.Error, "Ukjent ModalType, dette skal aldri skje");
        return;
      }
      globalLoadingWrapper({ blocking: true }, async () => {
        await api.appformtemplate.deleteAppFormTemplateAsync(props.existingItemModal.id);
        // TODO if not allowed
        openNotification(store, NotificationItemType.Success, "Påmeldingsskjemaet er slettet");
        emit("close");
      });
    };
    return { handleSubmit };
  },
});
